module.exports = __webpack_public_path__ + "static/media/mining_consensus_forks_bitcoin-studio.584b73de.jpg";